export interface LookDef {
    path: string;
    w: number;
    h: number;
    color: string;
    poses?: string[];
    rows?: number;
}

const look = (path: string, w: number, h: number, color: string, poses?: string[], rows?: number): LookDef =>
    ({ path, w, h, color, poses, rows });

const MARK_VARIANTS = ["a", "b", "c", "d", "e", "f", "g", "h"];

export const LOOKS = {
    player: look("sprites/player.png", 160, 160, "#e53935", [
        "down", "left30", "left60", "left90", "pedal_a", "pedal_b",
        "air", "superman", "no_hander", "crash", "fallen", "skid",
    ], 2),
    bigfoot: look("sprites/bigfoot.png", 256, 256, "#6d4c41", ["run_a", "run_b", "roar", "grab"]),
    dog: look("sprites/dog.png", 96, 96, "#d7a86e", ["sit", "run_a", "run_b", "tumble"]),
    hiker: look("sprites/hiker.png", 128, 128, "#1e88e5", ["walk_a", "walk_b", "startled"]),
    npc_rider: look("sprites/npc_rider.png", 160, 160, "#8e24aa", ["down", "left30", "left60", "left90", "fallen"]),
    wildlife: look("sprites/wildlife.png", 160, 128, "#f5f5f5", ["cow", "sheep", "deer", "marmot"]),

    marks_meadow: look("sprites/ground/marks_meadow.png", 64, 64, "#9ccc65", MARK_VARIANTS),
    marks_forest: look("sprites/ground/marks_forest.png", 64, 64, "#6b8e4e", MARK_VARIANTS),
    trail_marks: look("sprites/ground/trail_marks.png", 64, 64, "#b08560", MARK_VARIANTS),
    mud: look("sprites/ground/mud.png", 256, 128, "#5d4037"),
    puddle: look("sprites/ground/puddle.png", 128, 64, "#4e5d6c"),
    gravel: look("sprites/ground/gravel.png", 256, 128, "#9e9e9e"),
    roots: look("sprites/ground/roots.png", 256, 160, "#795548"),
    rock_garden: look("sprites/ground/rock_garden.png", 320, 192, "#757575"),

    rock_small: look("sprites/meadow/rock_small.png", 80, 56, "#90a4ae"),
    rock_large: look("sprites/meadow/rock_large.png", 176, 128, "#78909c"),
    outcrop: look("sprites/meadow/outcrop.png", 288, 176, "#607d8b"),
    bush: look("sprites/meadow/bush.png", 112, 80, "#2e7d32"),
    fence: look("sprites/meadow/fence.png", 128, 64, "#a1887f"),
    hay_bale: look("sprites/meadow/hay_bale.png", 112, 80, "#fbc02d"),
    roller: look("sprites/meadow/roller.png", 160, 56, "#a1662f"),
    berm: look("sprites/meadow/berm.png", 256, 160, "#8d6e63"),

    pine_small: look("sprites/forest/pine_small.png", 112, 160, "#1b5e20"),
    pine_large: look("sprites/forest/pine_large.png", 160, 224, "#174d1a"),
    tree_leafy: look("sprites/forest/tree_leafy.png", 192, 224, "#388e3c"),
    stump: look("sprites/forest/stump.png", 64, 48, "#8d6e63"),
    log: look("sprites/forest/log.png", 192, 64, "#6d4c41"),
    fern: look("sprites/forest/fern.png", 96, 64, "#66bb6a"),

    kicker: look("sprites/course/kicker.png", 128, 64, "#b07a45"),
    tabletop: look("sprites/course/tabletop.png", 256, 128, "#a0693a"),
    wood_ramp: look("sprites/course/wood_ramp.png", 128, 80, "#c49a6c"),
    drop: look("sprites/course/drop.png", 192, 96, "#b38b5d"),
    skinny: look("sprites/course/skinny.png", 64, 256, "#d2b48c"),
    lift_pylon: look("sprites/course/lift_pylon.png", 128, 320, "#546e7a"),
    lift_chair: look("sprites/course/lift_chair.png", 176, 176, "#37474f", ["empty", "two_riders", "one_rider"]),
    trail_sign: look("sprites/course/trail_sign.png", 96, 96, "#fafafa", ["green", "red", "black"]),
    warning_sign: look("sprites/course/warning_sign.png", 64, 96, "#ffca28"),
    tape_post: look("sprites/course/tape_post.png", 32, 96, "#ff7043"),
    gate_red: look("sprites/course/gate_red.png", 64, 128, "#e53935"),
    gate_blue: look("sprites/course/gate_blue.png", 64, 128, "#1e88e5"),
    start_banner: look("sprites/course/start_banner.png", 512, 160, "#43a047"),
    finish_banner: look("sprites/course/finish_banner.png", 512, 160, "#212121"),

    pickups: look("sprites/pickups.png", 64, 64, "#ffd600", ["energy_gel", "coin", "water_bottle", "lucky_helmet", "mystery_crate"]),

    shadow: look("sprites/shadow.png", 64, 24, "#333333"),
    puff: look("sprites/puff.png", 64, 64, "#d7ccc8"),
    splat: look("sprites/splat.png", 64, 64, "#6d4c41"),
    sparkle: look("sprites/sparkle.png", 32, 32, "#fff59d"),
};

export type LookKey = keyof typeof LOOKS;

export const FONT_UI = { key: "font_ui", path: "fonts/font_ui.woff2" };
